var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormaLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 613,
    height: 685,
    viewBox: "0 0 613 685",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.722 227.591C115.867 262.408 41.3474 67.5527 -88.4652 200.85C-152.14 265.203 -62.9435 421.923 -100.189 465.261C-298.939 696.144 67.9675 895.509 170.369 811.976C273.2 727.376 248.306 526.398 387.072 438.86C491.708 372.967 489.403 301.351 447.721 259.817C422.177 235.302 381.761 221.559 342.722 227.591Z",
    fill: "#89A3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormaLeft);
export default __webpack_public_path__ + "static/media/formaLeft.70ffda2f56fe2ae771d45a08d2f85a45.svg";
export { ForwardRef as ReactComponent };